<template>
  <Component
    :is="type"
    v-if="display"
    :show-dialog="display"
    :title="isPage ? undefined : dialogTitle"
    :width="375"
    :aria-close="$t('dialog.close.aria-label')"
    @update:show-dialog="dialogUpdated"
  >
    <h1 v-if="isPage" class="legacy-h4">
      {{ dialogTitle }}
    </h1>
    <VCardText class="font14 text-primary">
      <p class="mb-2">
        {{ $t('auth.dialog.p.instructions', { email }) }}
      </p>
      <p class="mb-2">
        {{ $t('auth.dialog.p.dontReceive') }}
      </p>
      <p class="mb-2">
        {{ $t('auth.dialog.p.linkToFaq') }}
        <NuxtLink to="/help/faqs?page=login" @click="emits('update:display', false)">
          {{ $t('auth.dialog.p.linkToFaq.clickHere') }}
        </NuxtLink>
      </p>
    </VCardText>
  </Component>
</template>

<script lang="ts" setup>
import SDialog from '~/components/SDialog.vue'
interface Props {
 dialogMode?: string
 email: string
 display?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  dialogMode: 'sent',
  display: true
})

const emits = defineEmits<{
  (e: 'update:display', value: boolean): void
}>()

const route = useRoute()
const { t } = useI18n()
const dialogUpdated = (showDialog: boolean) => {
  if (!showDialog) {
    emits('update:display', false)
  }
}

const isPage = computed(() => route.path.includes('/auth/sign-in'))
const type = computed(() => isPage.value ? SDialog : 'div')
const dialogTitle = computed(() => t('auth.dialog.sentPwdTitle', { action: props.dialogMode }))

</script>
<style lang="scss" scoped>
</style>
